import { Component, Inject, OnInit } from '@angular/core';

import { Paginacao } from "@app/models/util/paginacao";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

import { Pedido } from '@app/models/pedido.model';
import { PedidoService } from '@app/services/pedido.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pedido-lista',
  templateUrl: './pedido-lista.component.html'
})
export class PedidoListaComponent implements OnInit {

  lstPedido: Pedido[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private pedidoService: PedidoService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.pedidoService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstPedido = data.Dados,
        this.paginacao.totalDeItens = data.Total;
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(pedido: Pedido) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o pedido: " + pedido.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.pedidoService.deletar(pedido.Id).toPromise().then(
        () => {
          this.obterTodos(this.filtroDescricao, 1);
          this.paginacao.paginaAtual = 1;
        });
    }

  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
